import { ColumnState } from "ag-grid-community";
import { create } from "zustand";
import {
	defaultEQM2070_R01HeaderDto,
	EQM2070_R01DetailPivotDto,
	EQM2070_R01HeaderDto,
} from "./Dto_EQM2070_R01";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";

export const EQM2070_R01_DEFAULT_EQUIPMENT_CD = "PLATING";
export type EQM2070DetailTabType = "PLATING" | "PLATING2";

export interface EQM2070_R01Filter {
	compCd: string;
	equipmentCd: string;
	equipmentNm: string;
	inspectDt: string;
}

export interface Store_EQM2070_R01 {
	EQM2070_R01Filter: EQM2070_R01Filter;
	EQM2070_R01PastFilter: EQM2070_R01Filter;
	setEQM2070_R01Filter: (filter: Partial<EQM2070_R01Filter>) => void;
	setEQM2070_R01PastFilter: (filter: EQM2070_R01Filter) => void;

	EQM2070_R01List: EQM2070_R01HeaderDto[];
	setEQM2070_R01List: (dataList: EQM2070_R01HeaderDto[]) => void;

	editEQM2070_R01: EQM2070_R01HeaderDto | null;
	setEditEQM2070_R01: (editData: EQM2070_R01HeaderDto | null) => void;

	selectedEQM2070_R01: EQM2070_R01HeaderDto | undefined;
	setSelectedEQM2070_R01: (data: EQM2070_R01HeaderDto | undefined) => void;
	initSelectedEQM2070_R01: () => void;

	EQM2070_R01DetailPivotList: EQM2070_R01DetailPivotDto[];
	setEQM2070_R01DetailPivotList: (data: EQM2070_R01DetailPivotDto[]) => void;
	updateEQM2070_R01DetailPivot: (valueIndex: number, data: EQM2070_R01DetailPivotDto) => void;

	originalEQM2070_R01DetailPivotList: EQM2070_R01DetailPivotDto[];
	setOriginalEQM2070_R01DetailPivotList: (data: EQM2070_R01DetailPivotDto[]) => void;

	deletedEQM2070_R01DetailPivotList: string[];
	addDeletedEQM2070_R01DetailPivotList: (idList: string[]) => void;
	removeDeletedEQM2070_R01DetailPivotList: (idList?: string[]) => void;

	selectedEQM2070_R01DetailPivotList: string[];
	setSelectedEQM2070_R01DetailPivotList: (idList: string[]) => void;
	addSelectedEQM2070_R01DetailPivotList: (idList: string[]) => void;
	removeSelectedEQM2070_R01DetailPivotList: (idList?: string[]) => void;
	initSelectedEQM2070_R01DetailPivotList: () => void;
	allSelectedEQM2070_R01DetailPivotList: () => void;

	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultEQM2070_R01Filter: EQM2070_R01Filter = {
	compCd: "",
	equipmentCd: EQM2070_R01_DEFAULT_EQUIPMENT_CD,
	equipmentNm: "",
	inspectDt: formatDateYear4(new Date()) + "-" + formatDateMonth(new Date()),
};

export const useEQM2070_R01Store = create<Store_EQM2070_R01>((set) => ({
	EQM2070_R01Filter: defaultEQM2070_R01Filter,
	EQM2070_R01PastFilter: defaultEQM2070_R01Filter,
	setEQM2070_R01Filter: (update) =>
		set((state) => ({
			EQM2070_R01Filter: {
				...state.EQM2070_R01Filter,
				...update,
			},
		})),
	setEQM2070_R01PastFilter: (filter) =>
		set((state) => ({
			...state,
			EQM2070_R01PastFilter: filter,
		})),

	EQM2070_R01List: [],
	setEQM2070_R01List: (dataList) =>
		set((state) => ({
			...state,
			EQM2070_R01List: dataList,
		})),

	editEQM2070_R01: defaultEQM2070_R01HeaderDto,
	setEditEQM2070_R01: (editData) =>
		set((state) => ({
			...state,
			editEQM2070_R01: editData,
		})),

	selectedEQM2070_R01: undefined,
	setSelectedEQM2070_R01: (data) =>
		set((state) => ({
			...state,
			selectedEQM2070_R01: data,
			EQM2070_R01DetailPivotList: [],
			originalEQM2070_R01DetailPivotList: [],
			deletedEQM2070_R01DetailPivotList: [],
			selectedEQM2070_R01DetailPivotList: [],
		})),
	initSelectedEQM2070_R01: () =>
		set({
			selectedEQM2070_R01: undefined,
			editEQM2070_R01: defaultEQM2070_R01HeaderDto,
			EQM2070_R01DetailPivotList: [],
			originalEQM2070_R01DetailPivotList: [],
			deletedEQM2070_R01DetailPivotList: [],
			selectedEQM2070_R01DetailPivotList: [],
		}),

	EQM2070_R01DetailPivotList: [],
	setEQM2070_R01DetailPivotList: (data) =>
		set((state) => ({
			...state,
			EQM2070_R01DetailPivotList: data,
		})),
	updateEQM2070_R01DetailPivot: (valueIndex, data) =>
		set((state) => ({
			...state,
			EQM2070_R01DetailPivotList: state.EQM2070_R01DetailPivotList.map((item) =>
				item.valueIndex === valueIndex ? data : item,
			),
		})),

	originalEQM2070_R01DetailPivotList: [],
	setOriginalEQM2070_R01DetailPivotList: (list) =>
		set((state) => ({
			...state,
			originalEQM2070_R01DetailPivotList: list.map((row) => ({
				...row,
				dayValues: { ...row.dayValues },
				dayMeta: { ...row.dayMeta },
			})),
		})),

	deletedEQM2070_R01DetailPivotList: [],
	addDeletedEQM2070_R01DetailPivotList: (idList) =>
		set((state) => {
			const deletedList = [...state.deletedEQM2070_R01DetailPivotList];
			for (const valueIndex of idList) {
				const isInserted = state.EQM2070_R01DetailPivotList.find(
					(item) => item.valueIndex === Number(valueIndex) && item.inserted,
				);
				const isModified = state.EQM2070_R01DetailPivotList.find(
					(item) => item.valueIndex === Number(valueIndex) && item.isModified,
				);
				if (!isInserted && !isModified) {
					deletedList.push(valueIndex);
				}
			}
			return { ...state, deletedEQM2070_R01DetailPivotList: deletedList };
		}),
	removeDeletedEQM2070_R01DetailPivotList: (idList) =>
		set((state) => ({
			...state,
			deletedEQM2070_R01DetailPivotList: state.deletedEQM2070_R01DetailPivotList.filter(
				(value) => (idList ? !idList.includes(value) : false),
			),
		})),

	selectedEQM2070_R01DetailPivotList: [],
	setSelectedEQM2070_R01DetailPivotList: (idList) =>
		set({ selectedEQM2070_R01DetailPivotList: idList }),
	addSelectedEQM2070_R01DetailPivotList: (idList) =>
		set((state) => ({
			...state,
			selectedEQM2070_R01DetailPivotList: [
				...state.selectedEQM2070_R01DetailPivotList,
				...idList,
			],
		})),
	removeSelectedEQM2070_R01DetailPivotList: (idList) =>
		set((state) => ({
			...state,
			selectedEQM2070_R01DetailPivotList: state.selectedEQM2070_R01DetailPivotList.filter(
				(value) => (idList ? !idList.includes(value) : false),
			),
		})),
	initSelectedEQM2070_R01DetailPivotList: () =>
		set({ selectedEQM2070_R01DetailPivotList: [] }),
	allSelectedEQM2070_R01DetailPivotList: () =>
		set((state) => ({
			...state,
			selectedEQM2070_R01DetailPivotList: state.EQM2070_R01DetailPivotList.map((item) =>
				item.valueIndex.toString(),
			),
		})),

	detailColumnState: null,
	setDetailColumnState: (detailColumnState) => set({ detailColumnState }),

	detailScrollTop: null,
	setDetailScrollTop: (detailScrollTop) => set({ detailScrollTop }),

	allCount: 0,
	setAllCount: (allCount) => set({ allCount }),

	initData: () =>
		set((state) => ({
			...state,
			EQM2070_R01Filter: defaultEQM2070_R01Filter,
			EQM2070_R01PastFilter: defaultEQM2070_R01Filter,
			EQM2070_R01List: [],
			selectedEQM2070_R01: undefined,
			EQM2070_R01DetailPivotList: [],
			originalEQM2070_R01DetailPivotList: [],
			deletedEQM2070_R01DetailPivotList: [],
			selectedEQM2070_R01DetailPivotList: [],
			editEQM2070_R01: defaultEQM2070_R01HeaderDto,
			allCount: 0,
			detailScrollTop: null,
		})),
}));
